import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {GeneralOption} from '@core/interfaces/system/system-common';

@Component({
    selector: 'ngx-popup-select',
    templateUrl: './popup-select.component.html',
    styleUrls: ['./popup-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopupSelectComponent {
    @Input() options: GeneralOption[];
    @Output() onItemSelected: EventEmitter<GeneralOption> = new EventEmitter<GeneralOption>();
    constructor() {}

    public selectItem(item: GeneralOption) {
        this.onItemSelected.emit(item);
    }
}
